import { useContext } from "react";
import { Link } from "react-router-dom";

import { AuthContext } from "../../contexts/AuthContext";

import ASELogo from "../../assets/ase-logo.png";
import UserProfilePhoto from "../UserProfilePhoto";
import NavbarLink from "../NavbarLink";

import { DocumentIcon, LifebuoyIcon, UserMinusIcon, ClockIcon, BriefcaseIcon } from "@heroicons/react/24/outline";

const LabourerNavbar = () => {
  const { user } = useContext(AuthContext);

  return (
    <nav className="hidden md:flex justify-center py-4 shadow-md">
      <div className="container flex items-center justify-between">
        <Link to="/l">
          <img src={ASELogo} alt="ASE Group" className="h-[30px]" />
        </Link>

        <div className="flex items-center gap-2">
          <NavbarLink to="/l/clock-in" label="Clock-In" icon={<ClockIcon className="h-5 w-5 text-ase-blue" />} />
          <NavbarLink to="/l/my-work" label="My Work" icon={<BriefcaseIcon className="h-5 w-5 text-ase-blue" />} />
          <NavbarLink to="/l/licenses-and-documents" label="Licenses & Documents" icon={<DocumentIcon className="h-5 w-5 text-ase-blue" />} />
          <NavbarLink to="/l/leave-requests" label="Leave requests" icon={<UserMinusIcon className="h-5 w-5 text-ase-blue" />} />
          <NavbarLink to="/l/support" label="Support" icon={<LifebuoyIcon className="h-5 w-5 text-ase-blue" />} />

          <Link to="/l/profile" className="ml-2">
            <UserProfilePhoto
              photoUrl={user?.profilePicture}
              fullName={user?.fullName}
            />
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default LabourerNavbar;
